/* eslint react/forbid-prop-types: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';

import { appSetData } from '../redux/app/actions';

import Routes from '../Routes';

import Footer from '../components/Footer';

class App extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  }

  static contextTypes = {
    store: PropTypes.object,
  }
  componentDidMount() {
    const { store } = this.context;
    store.dispatch(appSetData());
  }
  render() {
    const childProps = {
      className: 'App-contents',
    };
    return (
      <div className="App">
        <ConnectedRouter history={this.props.history}>
          <Routes childProps={childProps} />
        </ConnectedRouter>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.jsx